module.exports = __webpack_public_path__ + "static/img/tik.88b693b1.png";